export const iconFontAwesomeMapsCakeCandles = (
	<i className="fa-solid fa-cake-candles"></i>
);
